import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { ScopeActions } from '../../+state/scope/scope.actions';
import { PractiseType } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { PractiseOverviewPageActions } from './practise.actions';
import { getPractiseTypesFromScopes } from '../scope/scope.functions';
import { SettingsActions } from '@lyceo/lyceo-pupil-app/user/data-access';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const PRACTISE_FEATURE_KEY: string = 'practise';

export interface PractiseState {
  scopeIds: string[];
  selectedPractiseType: PractiseType | undefined;
}

export const initialPractiseState: PractiseState = {
  scopeIds: [],
  selectedPractiseType: undefined,
};

const reducer: ActionReducer<PractiseState, Action> = createReducer(
  initialPractiseState,
  on(
    AuthActions.logoutSuccess,
    (state): PractiseState => ({
      ...initialPractiseState,
      selectedPractiseType: state.selectedPractiseType,
    }),
  ),
  on(
    SettingsActions.updateLevelYearSuccess,
    (state): PractiseState => ({
      ...state,
      scopeIds: [],
    }),
  ),
  on(ScopeActions.getPersonScopesSuccess, (state, action): PractiseState => {
    let currentPractiseType: PractiseType | undefined =
      state.selectedPractiseType;
    const availablePractiseTypes: PractiseType[] = getPractiseTypesFromScopes(
      action.scopes,
    );
    if (
      !currentPractiseType ||
      (currentPractiseType &&
        !availablePractiseTypes.includes(currentPractiseType))
    ) {
      currentPractiseType = availablePractiseTypes.length
        ? availablePractiseTypes[0]
        : undefined;
    }
    return {
      ...state,
      selectedPractiseType: currentPractiseType,
      scopeIds: action.scopes.map((scope) => scope.id),
    };
  }),
  on(
    PractiseOverviewPageActions.segmentClicked,
    (state, { practiseType }): PractiseState => ({
      ...state,
      selectedPractiseType: practiseType,
    }),
  ),
);

export function practiseReducer(
  state: PractiseState | undefined,
  action: Action,
): PractiseState {
  return reducer(state, action);
}
